
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import item from './articulos-lista-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Articulo: Articulo;
        @Prop() public Items: Articulo[];
        @Prop() public Seleccionado: number;
        @Prop() public Busqueda: string;
        @Prop() public Estado: string;



        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {


        }

    }
